// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__vJSF1","header":"Contacts_header__u16u1","goBack":"Contacts_goBack__0764s","container":"Contacts_container__dn7qr"};